// extracted by mini-css-extract-plugin
export var actionButton = "_n7-0";
export var actionMenuContainer = "_n7-i";
export var bubble = "_n7-2";
export var bubbleActionMenu = "_n7-j";
export var bubbleContext = "_n7-6";
export var bubbleItems = "_n7-7";
export var customer = "_n7-3";
export var divider = "_n7-8";
export var fileList = "_n7-9";
export var hiddenComment = "_n7-o";
export var infoAbove = "_n7-a";
export var internal = "_n7-4";
export var lightActionButton = "_n7-1";
export var link = "_n7-b";
export var merchant = "_n7-5";
export var message = "_n7-c";
export var profilePicture = "_n7-e";
export var quillToolbarContainer = "_n7-f";
export var senderDate = "_n7-g";
export var senderDateCustomer = "_n7-h";
export var senderName = "_n7-d";
export var time = "_n7-k";
export var uploadedImage = "_n7-l";
export var username = "_n7-m";
export var xsmall = "_n7-n";